'use client'

import { FC, useContext, useMemo, useState } from 'react'

import { BreadcrumbsContext } from './BreadcrumbsContext'
import { BreadcrumbsType, IBreadcrumbsProviderProps } from './types'

export const BreadcrumbsProvider: FC<IBreadcrumbsProviderProps> = ({
  children,
}) => {
  const [breadcrumbs, setBreadcrumbs] = useState<BreadcrumbsType>([])

  const contextvalue = useMemo(() => {
    return {
      breadcrumbs,
      setBreadcrumbs,
    }
  }, [breadcrumbs])

  return (
    <BreadcrumbsContext.Provider value={contextvalue}>
      {children}
    </BreadcrumbsContext.Provider>
  )
}

export const useBreadcrumbsProvider = () => useContext(BreadcrumbsContext)
